import { useQuery } from '@tanstack/react-query';

import { notificationKeys } from './useNotifications';
import { notificationRepository } from '../../infrastructure/repositories';

export function useUnreadNotificationCount() {
  return useQuery({ queryKey: notificationKeys.unreadCount(), queryFn: () => notificationRepository.getUnreadCount(), staleTime: 30 * 1000 });
}
